import React from "react";
import { Icon } from "./Icon";

const sizes = { sm: 32, md: 40, lg: 48 };

export function IconButton({ icon, label, variant = "ghost", size = "md", active = false, style = {}, ...rest }) {
  const [hover, setHover] = React.useState(false);
  const [press, setPress] = React.useState(false);
  const dim = sizes[size];
  const skin = {
    ghost: { background: hover ? "var(--surface-muted)" : "transparent", color: "var(--text-body)", border: "none" },
    solid: { background: hover ? "var(--action-primary-hover)" : "var(--action-primary)", color: "var(--text-on-primary)", border: "none", boxShadow: "var(--shadow-soft)" },
    outline: { background: hover ? "var(--linen)" : "transparent", color: "var(--text-body)", border: "1.5px solid var(--border-strong)" },
    inverse: { background: hover ? "var(--cream-a10)" : "transparent", color: "var(--text-inverse)", border: "none" },
  }[variant];
  return (
    <button
      type="button"
      className="fx-icon-btn"
      aria-label={label}
      aria-pressed={active || undefined}
      title={label}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); setPress(false); }}
      onMouseDown={() => setPress(true)}
      onMouseUp={() => setPress(false)}
      style={{
        width: dim, height: dim, display: "inline-flex", alignItems: "center", justifyContent: "center",
        borderRadius: "var(--radius-sm)", cursor: "pointer",
        transition: "background-color var(--duration-base) var(--ease-out), transform var(--duration-base) var(--ease-out)",
        transform: press ? "scale(var(--press-scale))" : "none",
        ...(active ? { background: "var(--action-primary)", color: "var(--text-on-primary)" } : null),
        ...skin, ...style,
      }}
      {...rest}
    >
      <Icon name={icon} size={size === "sm" ? 16 : size === "lg" ? 22 : 18} />
    </button>
  );
}
